import { useTranslation } from "react-i18next";
import Button from "../../components/common/button/Button";
import TitleUpdater from "../../components/common/title/TitleUpdater";
import styles from "./NotFound.module.scss";
import { useNavigate } from "react-router-dom";
const NotFound = () => {
  const { t } = useTranslation("translation");
  const navigate = useNavigate();
  return (
    <div id={styles.not_found_page}>
      <TitleUpdater title={t("not_found.title") as string} />
      <div className={styles.not_found_image}>
        <div className={styles.content}>
          <h1 className={styles.err_status}>404</h1>
          <p className={styles.oops}>{t("not_found.oops") as string}</p>
          <div className={styles.not_found_btn}>
            <Button onClick={() => navigate("/")}>
              {t("not_found.go_to_dashboard") as string}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
